export class Configuracion {
 
 
    public static CONTEXT_PATH_COTIZADOR = 'https://cotizador.sura.com/';
    public static CONTEXT_PATH_COTIZADORES = 'https://cotizadores.sura.com/';
 
    public static CONTEXT_PATH_LOGIN_COTIZADOR_CONTINUE_TO = 'https://cotizador.sura.com/prospectos-vida/login?continueTo=';
    public static CONTEXT_PATH_COTIZADORES_CONTINUE_TO = 'https%3A%2F%2Fcotizadores.sura.com%2F';
 
 
    // URL PARA DEFINIR EL CONTEXTO DE DESPLIEGUE
    //public static CONTEXT_PATH = 'https://cotizadores.sura.com/apigateway-ayvcotizador/';
    public static CONTEXT_PATH = 'https://cotizadores.sura.com/agw-home/';
 
 
    // URLS PARA REDIRECCION
    public static REDIRECCION_COTIZADOR_CONECTADO = 'https://cotizador.sura.com/CotizadorMovileView/';
    public static REDIRECCION_COTIZADOR_HOME = 'https://cotizadores.sura.com/#/';
    // tslint:disable-next-line:max-line-length
    public static REDIRECCION_ASESORIA_Y_VENTA = 'https://cotizadores.sura.com/agw-pvp/seus/login?url={AMB}%2Fasesoriayventa%2F%23%2F{TPL}%2F%3Ftipo%3D{TD}%26numero%3D{ND}%26prepararcita%3DN';
 
    // URLS OPCIONES COTIZADOR CONECTADO
    public static REDIRECCION_COTIZADOR_MIS_NEGOCIOS = 'misNegocios:misNegocios';
    public static REDIRECCION_COTIZADOR_MIS_CLIENTES = 'MisClientes:MisClientes';
    public static REDIRECCION_COTIZADOR_NUEVO_MIS_NEGOCIOS = 'mis-negocios';
    public static REDIRECCION_COTIZADOR_NUEVO_MIS_CLIENTES = 'mis-clientes';
    // tslint:disable-next-line:max-line-length
    public static REDIRECCION_COTIZADOR_MIS_MAPA = 'MapaRiesgosMisMapasDeRiesgo:MapaRiesgosMisMapasDeRiesgo';
    // tslint:disable-next-line:max-line-length
    public static REDIRECCION_COTIZADOR_MAPA_RIESGOS = 'MapaRiesgosNuevoMapa:MapaRiesgosNuevoMapa';
 
 
    // tslint:disable-next-line:max-line-length
    public static REDIRECCION_COTIZADOR_MIS_PLANES = 'MisPlanesTrabajo:MisPlanesTrabajo';
    public static REDIRECCION_COTIZADOR_FORMATOS = 'Formatos:Formatos';
    public static REDIRECCION_COTIZADOR_FORMATOSV2 = 'https://asesores.segurossura.com.co/document/formatos';
 
    public static REDIRECCION_CONTACTO = 'https://docs.google.com/forms/d/1hoxx42_tHUc0Ez2G4-eqGNPBeKomk1V_g9opWoUqZBY/viewform';
 
    public static HEADER_DESCRIPCION_PETICION = 'X-DESCRIPCION-PETICION';

    public static TOKEN_APP_TAG = 'appTag';
    public static TOKEN_XSRF = 'XSRF-TOKEN';

    public static URL_OBERVATORIO_OFERTA_ACEPTADA = 'https://forms.office.com/r/dCie60M30D';
    public static URL_OBERVATORIO_OFERTA_RECHAZADA = 'https://forms.office.com/r/v8vxD75fkS';
 
    // -----------------SERVICIOS SERVICE PROVIDERS EXTERNOS----------------------
    public static SP_EXTERNOS = ['agw-pvp/seus/user','apigateway-ayv-autos/seus/user', 'agw-mas-vida/seus/user', 'apigateway-rentas/seus/user',
    'planvive/seus/user','agw-pip/seus/user','apigateway-salud/seus/user','agw-pension/seus/user']

        //create header host-endpoint
    public static HEADER_HOST_ENDPOINT = 'x-host-endpoint';
    //create header host-port
    public static HEADER_HOST_PORT = 'x-host-port';
    //create header host-method
    public static HEADER_HOST_METHOD = 'x-host-method';
    //create header host-path
    public static HEADER_HOST_PATH = 'X-HOST-PATH';
    public static HEADER_HOST_ENDPOINT_REGULACION_VALUE = 'cotizador.sura.com';
    public static HEADER_HOST_PORT_REGULACION_VALUE = '443';
    public static HEADER_HOST_METHOD_REGULACION_VALUE = 'POST';

    public static URL_SSO_HOME = 'https://seus.sura.com/idp/idp-initiated/app/CotizadorHome';
    
}



// WEBPACK FOOTER //
// ./src/app/contants/configuracion.constant.ts